export const copyToClipboard = (text: string): void => {
  if (!text) {
    return;
  }

  const input: HTMLInputElement = document.createElement('input');
  input.style.width = '1px';
  input.style.height = '1px';
  input.style.position = 'absolute';
  input.style.top = '-9999px';
  input.value = text;

  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
};
